/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, MITSUB_S){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const h = 'is-hidden';
	const arrowPrev1 = '<button type="button" class="slick-prev"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left" /></svg></button>';
	const arrowNext1 = '<button type="button" class="slick-next"><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right" /></svg></button>';
	const arrowPrev2 = '<button type="button" class="slick-prev"><span><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_left02" /></svg></span></button>';
	const arrowNext2 = '<button type="button" class="slick-next"><span><svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right02" /></svg></span></button>';
	let $path = location.pathname;


	// <共通>
	const productImglazyLoad = () => {
		document.addEventListener("DOMContentLoaded", function () {
			var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

			if ("IntersectionObserver" in window) {
				var lazyImageObserver = new IntersectionObserver(function (entries, observer) {
					entries.forEach(function (entry) {
						if (entry.isIntersecting) {
							var lazyImage = entry.target;
							lazyImage.src = lazyImage.dataset.src;
							if (typeof lazyImage.dataset.srcset === "undefined") {
							} else {
								lazyImage.srcset = lazyImage.dataset.srcset;
							}
							lazyImage.classList.remove("lazy");
							if(lazyImage.classList.contains("lazy-img")) {
								lazyImage.addEventListener("load", function () {
									let wrapElm = getClosest(lazyImage, "figure.lazy-imgWrap");
									wrapElm.classList.add("is-loaded");
								});
							}
							lazyImageObserver.unobserve(lazyImage);
						}
					});
				}, { rootMargin: "50px" });

				lazyImages.forEach(function (lazyImage) {
					lazyImageObserver.observe(lazyImage);
				});

			} else {
				// Possibly fall back to a more compatible method here
			}
			function getClosest(node, selector) {
				return (node.closest || function (_selector) {
					do {
						if ((node.matches || node.msMatchesSelector).call(node, _selector)) {
							return node;
						}
						node = node.parentElement || node.parentNode;
					} while (node !== null && node.nodeType === 1);

					return null;
				}).call(node, selector);
			}
		});
	};

	// JSON取得
	const getJSONSbrandList = () => {
		return $.getJSON('/ajax/pickup/products_top.json');
	};
	const getJSONSbrandListBottom = () => {
		return $.getJSON('/ajax/pickup/products_bottom.json');
	};
	const getJSONsearchSecond = (_cat) => {
		return $.getJSON(`/ajax/pickup/products/second/${_cat}.json`);
	};
	const getJSONsearchThird = (_cat) => {
		return $.getJSON(`/ajax/pickup/products/third/${_cat}.json`);
	};
	const getJSONsearchTag = (_tag) => {
		return $.getJSON(`/ajax/pickup/products/tag/${_tag}.json`);
	};

	// <商品情報TOP>===========================================================================
	// <商品情報TOP>ブランドバナースライド
	const brandBnrSlider = () => {
		getJSONSbrandList().then((data) => {
			if(data.rt_bn_category_pickup_top.length) {
				let brandData = data.rt_bn_category_pickup_top[0].cf_pcp_category;
				for(let i=0; i<brandData.length; i++) {
					let _name = brandData[i].cf_pc_name3;
					let _img = brandData[i].cf_pc_third_img_name;
					let _cat1 = brandData[i].cf_pc_code1;
					let _cat2 = brandData[i].cf_pc_code2;
					let _cat3 = brandData[i].cf_pc_code3;
					let _url = brandData[i].cf_pc_third_url;

					let thisHtml = '<li class="__item"><div class="mod-boxLink-bg">'
						+ '<a href="'+ _url +'" target="_blank" class="__bnr">'
						+ '<figure><img src="/products_file/file/'+ _img +'" alt="'+ _name +'"></figure>'
						+ '</a></div></li>';
					$('.js-brand-slider').append(thisHtml);
				}
			}
		}).done(() => {
			$('.js-brand-slider').slick({
				infinite: true,
				speed: 1500,
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToShow: 5,
				arrows: false,
				dots: false,
				responsive: [
					{
						breakpoint: 1025,
						settings: {
							slidesToShow: 1,
						}
					}
				]
			});
		});

		// ページ下部「ブランド」
		getJSONSbrandListBottom().then((data) => {
			if(data.rt_bn_category_pickup_bottom.length) {
				let brandData = data.rt_bn_category_pickup_bottom[0].cf_pcp_category;
				for(let i=0; i<brandData.length; i++) {
					let _name = brandData[i].cf_pc_name3;
					let _cat1 = brandData[i].cf_pc_code1;
					let _cat2 = brandData[i].cf_pc_code2;
					let _cat3 = brandData[i].cf_pc_code3;
					let _url = '/'+ _cat1 +'/'+ _cat2 +'/';
					if(_cat1 === 'liquor') {
						_url +=  _cat3 +'/';
					}

					let thisHtml = '<li class="pure-u-1-5 pure-u-lg-1-2 space-u-30-child""><div class="mod-boxLink-bg">'
						+'<a href="'+ _url +'" class="mod-boxLink08">'
						+'<span class="__txt">'+  _name +'</span>'
						+'</a></div></li>';
					$('.js-brandList-bottom').append(thisHtml);
				}
			}
		});
	};
	// <商品情報TOP>ピックアップコンテンツスライド
	const pickupBnrSlider = () => {
		$('.products-idx-pickup-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 3,
			arrows: true,
			dots: false,
			prevArrow: arrowPrev2,
			nextArrow: arrowNext2,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	};
	// <商品情報TOP>「関連サイト」スライド
	const relationBnrSlider = () => {
		$('.products-idx-relation-slider').slick({
			infinite: true,
			speed: 1500,
			autoplay: true,
			autoplaySpeed: 3000,
			slidesToShow: 4,
			arrows: true,
			dots: false,
			prevArrow: arrowPrev1,
			nextArrow: arrowNext1,
			responsive: [
				{
					breakpoint: 1025,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	};
	// <商品情報TOP>「商品ラインナップ」More
	const lineupListMore = (_idx) => {
		let $activeTab = $('.js-tab-content').eq(_idx);
		let $lineupList = $activeTab.find('.js-lineupList li');
		let $moreBtn = $activeTab.find('.js-lineupList-more');
		if($lineupList.length) {
			let startCnt = 0, endCnt = 12;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($lineupList.eq(i).length) {
						$lineupList.eq(i).addClass(v);
						$moreBtn.addClass(v);
					} else {
						$moreBtn.remove();
						break;
					}
				}
			};
			// 最初の12件表示
			addResult();
			if($lineupList.length <= 12) { $moreBtn.remove(); }
			// moreボタン押下で残りを表示
			$moreBtn.on('click', () => {
				$lineupList.addClass(v);
				$moreBtn.remove();
			});
		}
	};
	// <商品情報TOP>「商品ラインナップ」
	const lineupList = () => {
		// 1つ目のタブ
		lineupListMore(0);
		// タブチェンジ時
		$('.js-tabChange').each((idx, ele) => {
			$(ele).on('click', (e) => {
				lineupListMore(idx);
			});
		});
	};
	// <商品情報TOP>カテゴリボタンカレント
	const topCategoryCurrent = () => {
		let param = location.search;
		if(param.indexOf('category') !== -1) {
			let thisCat = param.split('category')[1].split('&')[0].replace('=', '');
			$('.js-tabChange').removeClass(a);
			$('.js-tabChange[data-cat="'+ thisCat +'"]').addClass(a);
			$('.js-tab-content').removeClass(a);
			$('.js-tab-content[data-cat="'+ thisCat +'"]').addClass(a);
			$('.js-tabChange').each((idx, ele) => {
				if($(ele).hasClass(a)) {
					lineupListMore(idx);
					// スクロールで移動
					$('html, body').css('display', 'none');
					setTimeout(() => {
						$('html, body').css('display', 'block');
						var pos = $('#lineup').offset().top;

						if(MITSUB_S.va.window.width < MITSUB_S.va.device.desktop) {
							pos -= 60;
						} else {
							pos -= 120;
						}
						$('html,body').stop().animate({ scrollTop: pos }, 1200, 'easeOutExpo');
					}, 100);
				}
			});
		}
	};

	// ======================================================================================
	// <カテゴリ別一覧・商品検索> ================================================================
	// <商品検索>
	const productsMenu = () => {
		const $menuBlock = $('.js-productsMenuBlock');
		let scrollTopNow;
		let widthFlag = '';

		const fixedOnContainer = () => {
			scrollTopNow = $(window).scrollTop();
			$('.container').css({
				position: 'fixed',
				width: '100%',
				top: -1 * scrollTopNow,
				left: 0
			});
			$('body').addClass(f);
		};
		const fixedOffContainer = () => {
			$('.container').css({
				position: 'static'
			});
			$('body').removeClass(f);
			$(window).scrollTop(scrollTopNow);
		};

		const widthCheck = () => {
			let winWidth = $(window).width();
			if(winWidth <= MITSUB_S.va.device.desktop && widthFlag !== 'sp') {
				// SP処理
				widthFlag = 'sp';
				if($('.mod-sideNav-nav').hasClass(a)) {
					fixedOnContainer();
				}
			} else if(winWidth > MITSUB_S.va.device.desktop && widthFlag !== 'pc') {
				// PC処理;
				widthFlag = 'pc';
				fixedOffContainer();
			}
		};

		$(window).on('resize', () => {
			widthCheck();
		}).resize();


		// 商品検索ブロック開閉
		$('.js-productsMenu-open').on('click', (e) => {
			$(e.currentTarget).addClass(h);
			$menuBlock.addClass(a);
			if(widthFlag === 'sp') {
				fixedOnContainer();
			}
		});
		$('.js-productsMenu-close').on('click', (e) => {
			$menuBlock.removeClass(a);
			$('.js-productsMenu-open').removeClass(h);
			if(widthFlag === 'sp') {
				fixedOffContainer();
			}
		});

		// 第一カテゴリ
		$('.products-menuBlock-head').on('click', (e) => {
			let $this = $(e.currentTarget);
			let $next = $this.next('.products-menuBlock-body');
			$('.products-menuBlock-head').not($this).removeClass(a);
			$('.products-menuBlock-head').not($this).find('.mod-radio-input').prop('checked', false);
			$('.products-menuBlock-body').not($next).slideUp(400);
			$('.products-menuBlock-body').not($next).find('.mod-check-input').prop('checked', false);
		});
	};

	const categoryItemDisplay = () => {
		$('.js-category-item-name').each((idx, ele) => {
			let thisCatName = $(ele).text();
			let catName = $(ele).parents('.js-category-wrap').find('.js-category-name').text();
			if(thisCatName === catName) {
				$(ele).parents('.js-category-wrap').addClass(a);
			} else {
				$(ele).parents('.js-category-item').remove();
				$(ele).parents('.js-category-wrap').remove();
			}
		})

		productsListMoreCategory();
	};

	//<商品検索>
	const productsSearch = () => {
		let param = location.search.split('&');
		let thisKeyWord = '';
		let thisCategoryArr = [];
		let thisCategory1 = [];
		let thisCategory2 = [];
		let thisTag = [];
		let thisCategory1Txt = [];
		let thisCategory2Txt = [];
		let thisTagTxt = [];

		// <酒>国産・輸入　重複要削除
		$('.js-check[value="domestic"]').slice(0, -1).parents('.products-menuBlock-list-li.rt_bn_category_liquor').remove();
		$('.js-check[value="import"]').slice(0, -1).parents('.products-menuBlock-list-li.rt_bn_category_liquor').remove();

		for(let i = 0; i < param.length; i++) {
			let thisKey = param[i].split('=')[1];
			if(param[i].indexOf('p_keyword') !== -1) {
				thisKeyWord = thisKey;
			} else if(param[i].indexOf('p_category_1') !== -1) {
				thisCategory1.push(thisKey);
			} else if(param[i].indexOf('p_category_2') !== -1) {
				thisCategory2.push(thisKey);
			} else if(param[i].indexOf('p_tag') !== -1) {
				thisTag.push(thisKey);
			}
		}


		for(let i = 0; i < thisCategory1.length; i++) {
			getJSONsearchSecond(String(thisCategory1[i])).then((data) => {
				if(data.rt_bn_category.length) {
					let thisName = data.rt_bn_category[0].cf_pc_name2;
					if($('.js-head-item-txt').text() === '') {
						$('.js-head-item-txt .__second').append(thisName);
					} else {
						$('.js-head-item-txt .__second').append(','+ thisName);
					}
					$('.js-head-item').removeClass('di_none');
				}
			});
		}
		for(let i = 0; i < thisCategory2.length; i++) {
			getJSONsearchThird(String(thisCategory2[i])).then((data) => {
				if(data.rt_bn_category.length) {
					let thisName = data.rt_bn_category[0].cf_pc_name3;
					if($('.js-head-item-txt').text() === '') {
						$('.js-head-item-txt .__third').append(thisName);
					} else {
						$('.js-head-item-txt .__third').append(','+ thisName);
					}
					$('.js-head-item').removeClass('di_none');
				}
			});
		}
		for(let i = 0; i < thisTag.length; i++) {
			getJSONsearchTag(String(thisTag[i])).then((data) => {
				if(data.rt_bn_tag.length) {
					let thisName = data.rt_bn_tag[0].cf_pt_name_d;
					if($('.js-head-item-txt').text() === '') {
						$('.js-head-item-txt .__tag').append(thisName);
					} else {
						$('.js-head-item-txt .__tag').append(','+ thisName);
					}
					$('.js-head-item').removeClass('di_none');
				}
			});
		}



		if(thisKeyWord !== '') {
			$('.js-head-keyword').removeClass('di_none');
		}

		// $('.js-check').each((idx, ele) => {
			// if(thisCategoryArr.indexOf($(ele).val()) !== -1) {
			// 	$(ele).prop('checked', true);
			// 	thisCategoryTxt.push($(ele).next('.mod-check-text').text());
			// 	$('.js-head-item').removeClass('di_none');
			// 	// $(ele).parents('.products-menuBlock-body').prev('.products-menuBlock-head').find('.mod-radio-input').prop('checked', true);
			// }
		// });
		$('.js-check[checked="checked"').parents('.products-menuBlock-body').prev('.products-menuBlock-head').find('.mod-radio-input').prop('checked', true);

		$('.js-head-keyword-txt').text(decodeURI(thisKeyWord));
		$('.js-keyword').val(decodeURI(thisKeyWord));
	};

	// <検索結果
	// 「商品一覧」もっと見る 
	const productsListMore = () => {
		const $productsList = $('.js-productsList li');
		if($productsList.length) {
			let startCnt = 0, endCnt = 20;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($productsList.eq(i).length) {
						$productsList.eq(i).addClass(v);
						$('.js-productsList-more').addClass(v);
					} else {
						$('.js-productsList-more').remove();
						break;
					}
				}
			};
			// 最初の20件表示
			addResult();
			if($productsList.length <= 20) { $('.js-productsList-more').remove(); }
			// moreボタン押下で20件ずつ追加表示
			$('.js-productsList-more').on('click', () => {
				startCnt += 20; endCnt += 20;
				addResult();
			});
		}
	};

	// <カテゴリ別商品一覧>
	// 「商品一覧」もっと見る
	const productsListMoreCategory = () => {
		const $productsList = $('.js-productsList .js-category-item');
		if($productsList.length) {
			let startCnt = 0, endCnt = 20;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($productsList.eq(i).length) {
						$productsList.eq(i).addClass(v);
						$('.js-productsList-more').addClass(v);
						$productsList.eq(i).parents('.js-category-wrap').find('.js-category-name').addClass(a);
					} else {
						$('.js-productsList-more').remove();
						break;
					}
				}
			};
			// 最初の20件表示
			addResult();
			if($productsList.length <= 20) { $('.js-productsList-more').remove(); }
			// moreボタン押下で20件ずつ追加表示
			$('.js-productsList-more').on('click', () => {
				startCnt += 20; endCnt += 20;
				addResult();
			});
		}
	};

	// 「ブランドバナー」もっと見る
	const brandListMore = () => {
		const $brandList = $('.js-brandList li');
		if($brandList.length) {
			let startCnt = 0, endCnt = 15;
			const addResult = () => {
				for(let i=startCnt; i<endCnt; i++) {
					if($brandList.eq(i).length) {
						$brandList.eq(i).addClass(v);
						$('.js-brandList-more').addClass(v);
					} else {
						$('.js-brandList-more').remove();
						break;
					}
				}
			};
			// 最初の10件表示
			addResult();
			if($brandList.length <= 15) { $('.js-brandList-more').remove(); }
			// moreボタン押下で20件ずつ追加表示
			$('.js-brandList-more').on('click', () => {
				startCnt += 15; endCnt += 15;
				addResult();
			});
		}
	};
	// 「ブランドバナー」カレントブランドを非表示
	const brandListCurrent = () => {
		$('.js-category-brandBnr').each((idx, ele) => {
			if($(ele).attr('href') === $path || $(ele).attr('href') + 'index.html' === $path) {
				$(ele).parents('.js-category-brand').remove();
			}
		});
	}
	// カテゴリボタン&パンくず　カレント＆遷移
	const categoryCurrent = () => {
		// js-topicPath-category1
		$('.js-category').find('.mod-tab02').each((idx, ele) => {
			let thisCat = $(ele).attr('data-cat');
			if($path.indexOf(thisCat) !== -1) {
				$(ele).addClass(a);
			}
		});
		$('.js-category .mod-tab02').on('click', (e) => {
			let thisCat = $(e.currentTarget).attr('data-cat');
			location.href = '/products/?category='+ thisCat;
		});
		// パンくず
		$('.js-topicPath-category1').on('click', (e) => {
			event.preventDefault();
			let thisCat = $(e.currentTarget).attr('href').slice(1).slice(0,-1);
			location.href = '/products/?category='+ thisCat;
		});
	};

	// 酒 年齢確認
	const liquorConfirm = () => {
		let modal = $('.products-confirm');
		let opacity = 0.9;
		let button = $('.js-modal-close');
		let limit = 120;
		let cookie = $.cookie('modal');

		if(cookie !== 'off'){
			modal.addClass(v);
		}
		button.click(function(){
			modal.removeClass(v);
			let clearTime = new Date();
			clearTime.setTime(clearTime.getTime()+(limit*60*1000));
			$.cookie('modal', 'off', {expires:clearTime, path:"/"});
		});
		$('.remove_cookie').click(function(){
			$.removeCookie('modal', {expires:-1, path:"/"});
			location.reload();
		});
	};


	// ======================================================================================
	// <商品詳細>
	// 「このページをシェアする」
	const snsShare = () => {
		if($('.js-share-line').length) {
			$('.js-share-line').attr('href', 'https://social-plugins.line.me/lineit/share?url='+location.href);
		}
		if($('.js-share-twitter').length) {
			$('.js-share-twitter').attr('href', 'https://twitter.com/share?url='+location.href);
		}
		if($('.js-share-facebook').length) {
			$('.js-share-facebook').attr('href', 'http://www.facebook.com/share.php?u='+location.href);
		}
	};

	// 関連商品
	const relationProducts = () => {
		let $cat = $('.js-relation-products .rt_bn_product_detail .rt_cf_p_tag').text();
		$('.js-relation-products-item').each((idx, ele) => {
			let thisCat = $(ele).find('.__tag').text();
			if(thisCat !== $cat) {
				$(ele).remove();
			}
			if($path === $(ele).find('.mod-boxLink10').attr('href')) {
				$(ele).remove();
			}
		});

		if($('.js-relation-products-item').length) {
			$('.js-relation-products-item').slice(0, 4).removeClass('di_none');
			$('.js-relation-products').removeClass('di_none');
		}
	}

	// 基本情報・サブ画像など
	const detailItemDisplay = () => {
		if($('.products-detail-img-sub-img').length) {
			$('.products-detail-img-sub').addClass(v);
		}
		if($('.js-pairing-block').length) {
			if(!$('.js-pairing-block .products-detail-liquor-block').find('div').length) {
				$('.js-pairing-block').remove();
			}
		}
		if($('.js-tbl-block').length) {
			$('.js-tbl-block').each((idx, ele) => {
				if(!$(ele).find('table').find('tr').length) {
					$(ele).remove();
				}
			})
		}

		// 栄養成分表示
		if($('.js-nutritional').length) {
			if(!$('.js-nutritional').find('tr').length) {
				$('.js-nutritional').remove();
			}
		}

		if($('.js-liquor-block').length) {
			$('.js-liquor-block table').each((idx, ele) => {
				if(!$(ele).find('tr').length) {
					$(ele).remove();
				}
			});
			if(!$('.js-liquor-block table').length) {
				$('.js-liquor-block').remove();
			}
		}
		if($('.js-recipe').length) {
			if(!$('.js-recipe').find('div').length) {
				$('.js-recipe').addClass('di_none');
			}
		}
		if($('.js-youtube').length) {
			if(!$('.js-youtube').find('iframe').length) {
				$('.js-youtube').addClass('di_none');
			}
		}

		// 注釈
		if($('.js-text-display').length) {
			if($path.indexOf('frozenandchilledfoods') !== -1) {
				$('.js-text-display').addClass('di_none');
			}
		}
	};


	// ==============================================================================
	// <共通>========================================================================
	productImglazyLoad();
	if($('.js-productsMenuBlock').length) {
		productsSearch();
		window.onload = () => {
			productsMenu();
		};
	}

	// <商品情報TOP>==================================================================
	if($('.products-idx-brand-slider').length) {
		brandBnrSlider();
	}
	if($('.products-idx-pickup-slider').length) {
		pickupBnrSlider();
	}
	if($('.products-idx-relation-slider').length) {
		relationBnrSlider();
	}
	if($('.js-lineupList-more').length) {
		lineupList();
	}
	if(location.pathname === '/products/' || location.pathname === '/products/index.html') {
		window.addEventListener('load', function() {
			topCategoryCurrent();
		});
	}
	// <カテゴリ別商品一覧>==============================================================
	if($('.js-brandList li').length) {
		brandListCurrent();
		brandListMore();
	}
	if($('.js-category').length) {
		categoryCurrent();
	}
	if($('.js-category-name').length) {
		categoryItemDisplay();
	}
	if($path === '/products/search/result.html') {
		productsListMore();
	}
	if($path.indexOf('/liquor/') !== -1) {
		liquorConfirm();
	}
	// 商品詳細=======================================================================
	snsShare();
	detailItemDisplay();
	if($('.js-relation-products').length) {
		relationProducts();
	}


})(window.jQuery, window.MITSUB_S);
